import uuid4 from "uuid/v4";

function getCookie(name) {
    var matches = document.cookie.match(
        new RegExp("(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") + "=([^;]*)")
    );
    return matches ? decodeURIComponent(matches[1]) : undefined;
}

function setCookie(name, value) {
    document.cookie = `${name}=${value}; domain=.glavnoe.life; path=/`;
}

export function getUid() {
    const uid = getCookie("uid");

    if (uid) {
        return uid;
    }

    console.log("calc uid");

    const hash = uuid4();

    setCookie("uid", hash);

    return hash;
}
